/* Package JSON Import will be here */
import React from "react";
import { Row, Col } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import ProductItem from "components/products/ProductItem";
import Constants from "utilities/appConstants";
/* Project Import will be here */

const ProductList = ({ products, orders, addSpecificRelevantItemsToCart, pageType }) => {
  return (
    <div className="product--list--sec pb-60">
      <Row>
        {products.groupIds.map((key) => (
          <Col
            span={24}
            md={(pageType === Constants.SCHEME_DETAILS || pageType === Constants.BANNER_DETAILS) ? 24 : 12}
            key={key}
            className="product--list--item product-card-padding"
          >
            <ProductItem
              pageType={pageType}
              variants={products.group[key]}
              products={products.data}
              addSpecificRelevantItemsToCart={addSpecificRelevantItemsToCart}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ProductList;